define.alias("shared/utils/array-filters/get-last-value", "media/utils/array-filters/get-last-value");